import React, { useEffect } from 'react';
import { useStaticQuery, graphql, navigate } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import loading from '../assets/loading.svg';

export default function NotFoundPage() {
  const data = useStaticQuery(graphql`
    query {
      allEpisodesJson {
        totalCount
        edges {
          node {
            fields {
              slug
            }
          }
        }
      }
    }
  `);

  const episodes = [
    ...data.allEpisodesJson.edges,
    {
      node: {
        fields: { slug: `dQw4w9WgXcQ-rick-astley` },
      },
    },
  ];

  const getRandomEpisodeUrl = () =>
    `/episodes/${
      episodes[Math.floor(Math.random() * episodes.length)].node.fields.slug
    }`;

  useEffect(() => {
    const timeout = setTimeout(
      () => navigate(getRandomEpisodeUrl(), { replace: true }),
      1000
    );
    return () => clearTimeout(timeout);
  }, []);

  return (
    <Layout>
      <SEO title="Getting random episode..." />
      <div className="grid grid-cols-1 gap-2 place-items-center mt-20 mb-10">
        <h3 className="mb-8">Getting random episode...</h3>
        <img src={loading} />
      </div>
    </Layout>
  );
}
